import React from "react";
import { Link } from "gatsby";
import { AnimatePresence, motion } from "framer-motion";
import { useGlobalContext } from "../../utils/context";
import { CgClose } from "react-icons/cg";
import { HiOutlineMenu } from "react-icons/hi";

export default function MobileNav() {
  const {
    showNavbar,
    setShowNavbar,
    links,
    mobileVariants,
    itemVariants,
    open,
    cycleOpen,
  } = useGlobalContext();

  return (
    <nav className="block lg:hidden">
      <div className="bg-novaDarkGrey rounded-full mx-auto px-12 fixed top-8 -mb-12 z-50 py-4 inset-x-0 max-w-max">
        <Link
          to={"/"}
          className="py-5">
          <img
            src="https://novacom.group/gatsby/wp-content/uploads/2025/02/novacom-logo.svg"
            alt="Novacom"
            layout="fixed"
            width={116}
            height={16}
            className="block mx-auto"
          />
        </Link>
      </div>

      <div onClick={cycleOpen}>
        <button
          type="button"
          onClick={() => setShowNavbar(!showNavbar)}
          className="items-center block hover:text-black hover:border-black fixed right-8 top-8 z-50"
          aria-label="Show Navbar"
        >
          <span className="bg-novaYellow2 block w-12 h-12 pt-[8px] rounded-full border-2 border-novaDarkGrey">
            {!showNavbar ? (
              <HiOutlineMenu className="inline-block text-3xl text-novaBlue" />
            ) : (
              <CgClose className="inline-block text-3xl text-novaBlue" />
            )}
          </span>
        </button>
      </div>

      <div className="fixed z-40 block top-0 xl:hidden ">
        <div
          className={`top-0 right-0 w-screen mx-auto text-white fixed h-screen z-40 ease-in-out duration-500 ${
            showNavbar ? "translate-y-0 " : "-translate-y-full delay-1500"
          }`}
        >
          <div
            className="w-screen h-screen  bg-novaPink  text-white px-8 pt-28 text-center"
            onClick={cycleOpen}
          >
            <AnimatePresence>
              {open && (
                <motion.ul
                  initial="closed"
                  animate="open"
                  exit="closed"
                  variants={mobileVariants}
                >
                  {links.map(({ name, to, id, icon }) => (
                    <motion.li
                      key={id}
                      href={to}
                      whileHover={{ scale: 1.0000001 }}
                      variants={itemVariants}
                      className="py-1.5 my-2 text-xl"
                      onClick={() => setShowNavbar(!showNavbar)}
                    >
                      <Link href={to}>
                        <span className="text-3xl font-normal py-8">
                          {name} {icon}
                        </span>
                      </Link>
                    </motion.li>
                  ))}
                </motion.ul>
              )}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </nav>
  );
}
